import { onError, ErrorHandler } from '@apollo/client/link/error';
import { createHttpLink, HttpOptions, ServerParseError } from '@apollo/client/link/http';
import get from 'lodash/get';

import { logErrorToDatadog } from 'util/datadog';

const matchAppTrace = (bodyText?: string) => {
  if (!bodyText) {
    return null;
  }
  const matchGroups = bodyText.match(/((.*\n)*).*Full backtrace/);

  return matchGroups ? matchGroups[1] : '';
};

export const HTTP_LINK_CONFIG: HttpOptions = {
  uri: '/api/life/graph',
  credentials: 'same-origin',
};

// graph error middleware
export const errorHandler: ErrorHandler = ({
  networkError,
  graphQLErrors,
  response: topLevelResponse,
  operation,
}) => {
  const { operationName, variables } = operation;

  if (networkError) {
    const { response, statusCode, bodyText } = networkError as ServerParseError;

    let errorTitle = `${statusCode} Error`;

    if (get(response, 'statusText')) {
      errorTitle += ` (${response.statusText})`;
    }

    logErrorToDatadog(networkError, {
      error: errorTitle.trim(),
      page: window.location.href,
      backtrace: matchAppTrace(bodyText),
      operationName,
      variables,
      networkError: { ...networkError },
      graphQLErrors,
      description: get(networkError, 'result.errors', {}),
    });
  } else if (get(graphQLErrors, 'length')) {
    logErrorToDatadog(new Error('GraphQL Errors'), {
      page: window.location.href,
      operationName,
      variables,
      graphQLErrors,
    });
  }

  // show full error body in dev console
  if (process.env.NODE_ENV === 'development') {
    /* eslint-disable no-console */
    console.error('GRAPH ERROR:', {
      networkError: { ...networkError },
      graphQLErrors: { ...graphQLErrors },
      response: topLevelResponse,
      operation,
    });
  }
};

export const errorLink = onError(errorHandler);

// sets up graph endpoint, defines authentication method (cookie), and designates a fetch polyfill
export const networkLink = createHttpLink(HTTP_LINK_CONFIG);

export default errorLink.concat(networkLink);
